import React, { useEffect, useState, useRef } from "react";
import useUserStore from "../../utils/storeApp";
import MedInfoIcon from "../../assets/images/svg-icons-material-io/medical_information_FILL0_wght400_GRAD0_opsz48.svg";
import $ from "jquery";

const DetailsDirectory = () => {
  const [detailObj, setUserDetail] = useState([]);
  const { sharedObject } = useUserStore((state) => ({
    sharedObject: state.sharedObject,
  }));

  useEffect(() => {
    setUserDetail(sharedObject.userDirectSearch);
  }, [sharedObject.userDirectSearch]);

  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("detailsDirectoryModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
    $('#detailsDirectoryModal').modal('hide');
};
const isOrg = sharedObject?.AdvSearchAnswers?.DirectoryType !== "Providers";

  return (
    <div className="DetailsDirectory">
      <div 
        className="modal fade" 
        id="detailsDirectoryModal" 
        data-backdrop="static" 
        tabIndex="-1" 
        role="dialog" 
        aria-labelledby="detailsDirectorySearchTitle"
        aria-describedby="detailsDirectorySearchDesc"
        aria-modal="true"
     >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title spacer-inline text-size3" id="detailsDirectorySearchTitle" > Details </h2>
                <button 
                    type="button" 
                    className="close" 
                    aria-label="Close directory details" 
                    onClick={CloseModal} > 
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

              <div className="modal-body">
                <p id="detailsDirectorySearchDesc" className="sr-only">
                  {isOrg
                    ? "Organization contact details and direct email information."
                    : "Provider contact details, specialty, and direct email information."}
                </p>
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                        {isOrg ? (
                        <div>
                            <i className="bi bi-buildings-fill text-size5" aria-hidden="true"></i>
                            <div className="text-size6 ft-wt spacer-margin7">
                                {detailObj?.name}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <img src={MedInfoIcon} alt="" aria-hidden="true" />
                            <div className="text-size6 ft-wt spacer-margin7">
                                {detailObj?.name}
                            </div>
                        </div>
                    )}
                  </div>
                  <section className="field-wrapper" aria-label="Contact information">
                    <dl>
                      <dt>Address:</dt>
                      <dd className="sp-margin5">
                        {detailObj?.address}, 
                      </dd>
                      <dd className="sp-margin5">{detailObj?.city},</dd>
                      <dd className="sp-margin5">{detailObj?.state} </dd>
                      <dd>{detailObj?.zip}</dd><br />
                      <dt>Phone:</dt>703-222-3333
                      <dd className="sp-margin5">
                        {detailObj?.phone
                          ? formatPhoneNumber(detailObj?.phone.substring(0, 10))
                          : ""}
                      </dd>
                      <dt>Ext:</dt>703-222-3333
                      <dd className="sp-margin5">
                        {detailObj?.phone?.substring(
                          10,
                          detailObj?.phone.length
                        )}
                      </dd><br />
                      <dt>Fax:</dt>
                      <dd className="sp-margin5">
                        {detailObj?.fax
                          ? formatPhoneNumber(detailObj?.fax.substring(0, 10))
                          : ""}
                      </dd>
                      <dt>Ext:</dt>
                      <dd className="sp-margin5">
                        {detailObj?.fax?.substring(10, detailObj?.fax.length)}
                      </dd><br />
                      <dt>NPI:</dt>
                      <dd className="sp-margin5">{detailObj?.npi}</dd>
                    </dl>
                     </section>
                    {/*{sharedObject?.AdvSearchAnswers?.DirectoryType !==*/}
                    {/*    "Providers" ? (*/}
                    {/*    <div>*/}
                    {/*        <label>Organization Type:</label>*/}
                    {/*        <span className="sp-margin5">{detailObj?.orgKind}</span>*/}
                    {/*    </div>*/}
                    {/*) : null}*/}
                    <hr />
                    <section className="field-wrapper" aria-labelledby="specialtyHeading">
                        <span className="custom-label" id="specialtyHeading">Specialty</span>
                        <dl className="sub-catg sp-mx7" >
                            <dt className="sp-margin5">Type:</dt>
                            <dd> {detailObj?.specialityType}</dd><br />
                            <dt className="sp-margin5">Classification:</dt>
                            <dd>{detailObj?.specialityCLassification}</dd><br />
                            <dt className="sp-margin5">Specialization:</dt>
                            <dd>{detailObj?.specializationCode}</dd>
                        </dl>
                    </section>

                    <section aria-labelledby="directEmailHeading">
                      <span className="custom-label" id="directEmailHeading">Direct</span>
                      {!detailObj?.directEmail ? (
                        <>
                          <div className="field-wrapper sub-catg ctr" role="status">
                            No direct email addresses are currently available.
                          </div>
                        </>
                      ) : (
                        <div className="field-wrapper o-flow">
                          <table aria-label="Direct email addresses">
                              <caption className="sr-only">
                                Direct email addresses associated with this directory entry
                              </caption>
                              <thead>
                                    <tr>
                                      <th scope="col">Email</th>
                                      <th scope="col">Purpose</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                      <td className="word-set">{detailObj?.directEmail}</td>
                                      <td className="w-sm">{detailObj?.emailPurpose}</td>
                                    </tr>
                                </tbody>
                          </table>
                        </div>
                      )}
                  </section>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                    type="button" 
                    className="btn btn-outline-secondary" 
                    onClick={CloseModal}
                >
                  Close
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default DetailsDirectory;
